
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Europa Component Library`}</h1>
    <h2>{`europa.eu`}</h2>
    <p>{`This library will contain all available components that you can use to build your own website under the EU emblem (top level site of the `}<inlineCode parentName="p">{`europa.eu`}</inlineCode>{` domain).`}</p>
    <p>{`The design of the components for the EU branded sites are currently work in progress.`}</p>
    <p>{`Should you need to revamp or create a site communicating under the EU emblem (`}<inlineCode parentName="p">{`https://europa.eu/sitename`}</inlineCode>{`), please contact `}<a parentName="p" {...{
        "href": "mailto:Europamanagement@ec.europa.eu"
      }}>{`COMM Europa Management`}</a>{` (CEM) for support in building an EU branded website using the ECL.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;